import { Component, OnInit } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/firestore';
import { EcomicService } from './../../service/comics/ecomic.service';
import {Observable}from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { NovelSeason } from './../../models';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-e-novel-seasons',
  templateUrl: './e-novel-seasons.component.html',
  styleUrls: ['./e-novel-seasons.component.css']
})
export class ENovelSeasonsComponent implements OnInit {

Enovelseasoncol:AngularFirestoreCollection<NovelSeason>;
  Enovelseason:Observable<NovelSeason[]>;
  status: any = 'All';
  series: any = 'All';
  seriesdata: any;
  showseries: any = false;
  id:any;
  constructor(private afs:AngularFirestore,private ecomicService: EcomicService) { }

  async ngOnInit() {
    const seriesdata = await this.ecomicService.getnovelserious();
    seriesdata.subscribe(data => {
      this.seriesdata = data;
      this.showseries = true;
    });
    console.log(this.seriesdata);
    this.filterseasons();
  }
  filterseasons() {
    const key = this.status != 'All' ? 'status' : 'novel_series';
    const value = this.status != 'All' ? this.status : this.series ;
    this.Enovelseasoncol = this.afs.collection('Enovelseason', res => {
    if (this.status == 'All' && this.series == 'All') {
      return res.orderBy('createdAt', 'desc');
    } else {
      return res.orderBy('createdAt', 'desc').where(key, '==', value);
    }
    });
    this.Enovelseason = this.Enovelseasoncol.valueChanges();
  }


  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    console.log("vsdag")
    $('#DeleteModal').modal('hide');
    this.ecomicService.deleteseries('Enovelchapter','novel_seasons',this.id).then(status =>{
      if(status){
        this.afs.doc('/Enovelseason/'+this.id).delete().then(function () {  
          swal('Deleted!', 'Your List has been deleted.', 'success');
        }).catch(function(error){
          swal('Error!', error, 'error');
          console.error("error in removing document:",error);
        });
      } else {
        swal('Error!', 'Your are not permitted to delete.', 'error');
        console.log('not permited');
        
      }
    })
     
  }

}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-seasons/e-novel-seasons.component.ts